<template>
    <div>
        <keep-alive>
            <component v-if="postLoaded" class="main flex flex-col" :is="page" />
            <div v-else>not loaded</div>
        </keep-alive>
        <div class="mx-auto flex flex-row justify-between text-lg w-2/12 my-16">
            <router-link class="mr-2" :to="`${this.backUrl}`">{{ back }}</router-link>

            <router-link class="ml-2" :to="`${this.nextUrl}`">{{ next }}</router-link>
        </div>
    </div>
</template>

<script>
export default {
    props: ['slug', 'issue', 'componentName', 'author'],
    components: {
        FA1Texto1: () => import('@/components/FA1/FA1Texto1'),
        FA1Texto2: () => import('@/components/FA1/FA1Texto2'),
        FA1Texto3: () => import('@/components/FA1/FA1Texto3'),
        FA1Texto4: () => import('@/components/FA1/FA1Texto4'),

        FA2Texto1: () => import('@/components/FA2/FA2Texto1'),
        FA2Texto2: () => import('@/components/FA2/FA2Texto2'),
        FA2Texto3: () => import('@/components/FA2/FA2Texto3'),
        FA2Texto4: () => import('@/components/FA2/FA2Texto4'),
        FA2Texto5: () => import('@/components/FA2/FA2Texto5'),

        FA3Texto1: () => import('@/components/FA3/FA3Texto1'),
        FA3Texto2: () => import('@/components/FA3/FA3Texto2'),
        FA3Texto3: () => import('@/components/FA3/FA3Texto3'),
        FA3Texto4: () => import('@/components/FA3/FA3Texto4'),
        FA3Texto5: () => import('@/components/FA3/FA3Texto5'),

        FA4Texto1: () => import('@/components/FA4/FA4Texto1'),
        FA4Texto2: () => import('@/components/FA4/FA4Texto2'),
        FA4Texto3: () => import('@/components/FA4/FA4Texto3'),
        FA4Texto4: () => import('@/components/FA4/FA4Texto4'),
        FA4Texto5: () => import('@/components/FA4/FA4Texto5'),

        FA5Texto1: () => import('@/components/FA5/FA5Texto1'),
        FA5Texto2: () => import('@/components/FA5/FA5Texto2'),
        FA5Texto3: () => import('@/components/FA5/FA5Texto3'),
        FA5Texto4: () => import('@/components/FA5/FA5Texto4'),
        FA5Texto5: () => import('@/components/FA5/FA5Texto5'),

        FA6Texto1: () => import('@/components/FA6/FA6Texto1'),
        FA6Texto2: () => import('@/components/FA6/FA6Texto2'),
        FA6Texto3: () => import('@/components/FA6/FA6Texto3'),
        FA6Texto4: () => import('@/components/FA6/FA6Texto4'),
        FA6Texto5: () => import('@/components/FA6/FA6Texto5'),

        FA7Texto1: () => import('@/components/FA7/FA7Texto1'),
        FA7Texto2: () => import('@/components/FA7/FA7Texto2'),
        FA7Texto3: () => import('@/components/FA7/FA7Texto3'),
        FA7Texto4: () => import('@/components/FA7/FA7Texto4'),
        FA7Texto5: () => import('@/components/FA7/FA7Texto5'),

        FA8Texto1: () => import('@/components/FA8/FA8Texto1'),
        FA8Texto2: () => import('@/components/FA8/FA8Texto2'),
        FA8Texto3: () => import('@/components/FA8/FA8Texto3'),
        FA8Texto4: () => import('@/components/FA8/FA8Texto4'),
        FA8Texto5: () => import('@/components/FA8/FA8Texto5'),

        FA9Texto1: () => import('@/components/FA9/FA9Texto1'),
        FA9Texto2: () => import('@/components/FA9/FA9Texto2'),
        FA9Texto3: () => import('@/components/FA9/FA9Texto3'),
        FA9Texto4: () => import('@/components/FA9/FA9Texto4'),
        FA9Texto5: () => import('@/components/FA9/FA9Texto5'),

        FA10Texto1: () => import('@/components/FA10/FA10Texto1'),
        FA10Texto2: () => import('@/components/FA10/FA10Texto2'),
        FA10Texto3: () => import('@/components/FA10/FA10Texto3'),
        FA10Texto4: () => import('@/components/FA10/FA10Texto4'),
        FA10Texto5: () => import('@/components/FA10/FA10Texto5'),
    },
    data() {
        return {
            back: 'Voltar',
            next: 'Próximo',
            comp: null,
            page: null,
            postLoaded: false,
            currentPost: null,
            nextUrl: null,
            backUrl: null,
        }
    },
    mounted() {
        if (this.$route.name == 'SinglePostView') {
            this.renderPost()
        }
    },
    watch: {
        $route: function (to, from) {
            if (this.$route.name == 'SinglePostView') {
                this.renderPost()
            }
        },
        page: function () {
            this.postLoaded = true
            return this.comp
        },
    },
    methods: {
        renderPost() {
            let issueList = this.$attrs.issues
            let currentIssueSlug = this.$route.params.issue
            let currentIssueObj = issueList.filter((e) => e.slug === currentIssueSlug)

            let currentIssuePosts = currentIssueObj[0].posts

            let currentPostSlug = this.$route.params.slug
            let currentPostObj = currentIssuePosts.filter((e) => e.postSlug === currentPostSlug)

            this.postLoaded = true
            this.page = currentPostObj[0].comp

            let posts = currentIssueObj[0].posts
            let postIndex = posts.findIndex((e) => e.postSlug === currentPostSlug)
            let postsLen = posts.length - 1

            if (postIndex === 0) {
                this.back = 'Voltar ao índice'
                this.backUrl = './'
            } else {
                this.back = 'Voltar'
                this.backUrl = posts[postIndex - 1].postSlug
            }
            if (postIndex === postsLen) {
                this.next = 'Voltar ao índice'
                this.nextUrl = './'
            } else {
                this.next = 'Próximo'
                this.nextUrl = posts[postIndex + 1].postSlug
            }
        },
    },
    computed: {
        currentNavIndex: function () {
            let issueList = this.$attrs.issues
            let currentIssueSlug = this.$route.params.issue
            let currentIssueObj = issueList.filter((e) => e.slug === currentIssueSlug)
            let posts = currentIssueObj[0].posts
            let currentPostSlug = this.$route.params.slug
            let postIndex = posts.findIndex((e) => e.postSlug === currentPostSlug)
            let postsLen = posts.length - 1

            if (postIndex === 0) {
                this.back = currentIssueSlug
                this.backUrl = './'
            } else {
                this.back = 'Voltar'
                this.backUrl = posts[postIndex - 1].postSlug
            }
            if (postIndex === postsLen) {
                this.next = 'Voltar ao índice'
                this.nextUrl = './'
            } else {
                this.next = 'Próximo'
                this.nextUrl = posts[postIndex + 1].postSlug
            }
        },
    },
}
</script>

<style lang="postcss">
.main p {
    @apply text-2xl w-full md:w-text-block font-serif leading-tight mx-auto mb-5 px-4 md:px-0;
}
.main p:first-of-type {
    @apply mt-12;
}
.main p a {
    @apply font-normal underline;
}
.main h2 {
    @apply mt-12 mb-4 font-sans font-semibold w-full md:w-text-block mx-auto text-2xl px-4 md:px-0;
}
.main blockquote {
    @apply border-l-red border-l-2 uppercase text-4xl mb-8 mt-8 font-serif w-11/12 md:w-text-block pl-4 md:pl-4 ml-4 md:mx-auto;
}
.main .post_feature {
    @apply relative h-[25rem] md:h-screen bg-no-repeat bg-cover bg-center w-full -mt-20 flex items-center bg-black bg-local lg:bg-fixed;
}
.main .post_feature::after {
    content: ' ';
    filter: multiply;
    @apply absolute top-0 left-0 bg-black w-full h-full opacity-40;
}

.main p:first-of-type::first-letter {
    border-right: 2px solid theme('colors.black');
    @apply float-left font-semibold text-6xl mr-4 pr-4 mt-3;
}

.main h1 {
    filter: none;
    @apply text-4xl lg:text-8xl text-offwhite uppercase mx-auto font-serif w-1/2 my-auto text-center z-10 font-normal;
}
.main .article_feature {
    @apply text-black text-4xl lg:text-6xl text-center lg:text-left w-full lg:w-text-block mx-auto mt-24 mb-8 font-light;
}
.post_feature_caption,
.post_feature_credits {
    @apply px-4;
}
.post_feature_credits {
    @apply text-gray;
}
</style>
